module.exports = __webpack_public_path__ + "img/signin_icon__inputbox_password_normal.512cf6cc.svg";